import React from 'react'
import LandingLayout from '../../layouts/landing'
import { VStack } from '@chakra-ui/react'
import JobApplications from '../../components/JobApplications'

export const JobApplicationsSearch: React.FC = () => {
  return (
    <LandingLayout>
      <VStack>
        <JobApplications />
      </VStack>
    </LandingLayout>
  )
}

export default JobApplicationsSearch
